<template>
    <div :style="'width:'+buttonGroupWidth+'px; height:'+buttonGroupHeight+'px; position:relative; margin-top:12px'">
        <!-- ボタンのグループの背景 -->
        <table style="position:absolute; border-collapse:collapse; border-spacing:0">
            <tr>
                <td>
                    <v-img src="@/assets/icons/home_buttongroup_background.png" :width="buttonGroupWidth" :height="buttonGroupHeight" />
                </td>
            </tr>
        </table>
        <!-- ボタンのグループ -->
        <table style="position:absolute; border-collapse:collapse; border-spacing:0">
            <tr v-for="row in buttonGroupRowNum" :key="row">
                <td v-for="col in buttonGroupColumnNum" :key="row+'_'+col">
                    <!-- 空き -->
                    <template v-if="button(col, row) == null">
                        <v-btn width="120" height="120" color="transparent" elevation="1" tile class="pa-1" />
                    </template>
                    <!-- ライセンス -->
                    <template v-else-if="button(col, row).name == 'license'">
                        <!-- ライセンス所持 -->
                        <v-btn v-if="userLicense != null" width="120" height="120" @click="onClickUserLicense" color="transparent" elevation="1" tile class="pa-1">
                            <v-card outlined color="transparent">
                                <table >
                                    <tr>
                                        <td style="width:100%; text-align:center">
                                            <img v-if="userLicense.organization.avaterURL != ''" :src="userLicense.organization.avaterURL" :height="110" contain />
                                            <span v-if="userLicense.organization.avaterURL == '' && !$vuetify.breakpoint.xs">{{userLicense.organization.name}}</span>
                                            <span v-if="userLicense.organization.avaterURL == '' && $vuetify.breakpoint.xs">{{userLicense.organization.shortName}}</span>
                                        </td>
                                    </tr>
                                </table>
                            </v-card>
                        </v-btn>
                        <!-- ライセンス未所持 -->
                        <v-btn v-else width="120" height="120" @click="onClickSetLicense" color="transparent" elevation="1" tile class="pa-1">
                            <table >
                                <tr>
                                    <td>
                                        <v-layout justify-center>
                                            <v-img width="64" height="64" contain :src="buttonIconPath(col, row)" />
                                        </v-layout>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="text-align:center; font-size:small">
                                        <span class="font-weight-bold">ライセンス設定</span>
                                    </td>
                                </tr>
                            </table>
                        </v-btn>
                    </template>
                    <!-- 天気 -->
                    <template v-else-if="button(col, row).name == 'weather'">
                        <v-btn width="120" height="120" color="transparent" elevation="1" tile class="pa-1">
                            <Weather />
                        </v-btn>
                    </template>
                    <!-- その他 -->
                    <template v-else>
                        <v-btn width="120" height="120" @click="onClick(button(col, row))" color="transparent" elevation="1" tile class="pa-1">
                            <template v-if="button(col, row) != null && ((!isShareMode && button(col, row).nonShare) || (isShareMode && button(col, row).share))">
                                <table style="border-collapse:collapse; border-spacing:0; width:120px" >
                                    <tr>
                                        <td>
                                            <v-layout justify-center>
                                                <v-img width="64" height="64" contain :src="buttonIconPath(col, row)" />
                                            </v-layout>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding-top:4px; text-align:center">
                                            <span class="font-weight-black">{{button(col, row).tip}}</span>
                                        </td>
                                    </tr>
                                </table>
                            </template>
                        </v-btn>
                    </template>
                </td>
            </tr>
            <tr>
                <td :colspan="buttonGroupColumnNum" style="text-align:right">
                    <v-btn class="mt-2" x-small color="primary" fab @click="onClickCustomize"><v-icon>mdi-border-color</v-icon></v-btn>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import Weather from '@/components/tools/WeatherViewer3';
    export default {
        components: {
            Weather
        },
        data: function () {
            return {
                buttons: [
                    { name:"place", icon: "home_place", tip:"圃場", share: true, nonShare: true, position: 1 },
                    { name:"today_works", icon: "home_work", tip:"本日の作業", share: true, nonShare: true, position: 2 },
                    { name:"seedling", icon: "home_seedling", tip:"苗", share: true, nonShare: true, position: 3 },
                    { name:"box", icon: "home_box", tip:"環境BOX", share: true, nonShare: true, position: 4 },
                    { name:"notification", icon: "home_notification", tip:"通知", share: false, nonShare: true, position: 5 },
                    { name:"group", icon: "home_group", tip:"グループ", share: false, nonShare: true, position: 6 },
                    { name:"endShare", icon: "home_return_myhome", tip:"戻る", share: true, nonShare: false, position: 6 },
                    { name:"camera", icon: "home_album", tip:"アルバム", share: false, nonShare: true, position: 7 },
                    { name:"knowledge", icon: "home_knowledge", tip:"知識バンク", share: true, nonShare: true, position: 8 },
                    { name:"memo", icon: "home_memo", tip:"メモ", share: true, nonShare: true, position: 9 },
                    { name:"setting", icon: "home_setting", tip:"設定", share: true, nonShare: true, position: 10 },
                    { name:"weather", icon: "", tip:"", share: true, nonShare: true, position: 11 },
                    { name:"license", icon: "home_license", tip:"", share: true, nonShare: true, position: 12 },
                ],
            }
        },
        computed: {
            userLicense: function () {
                return this.$store.getters["loggedInUserLicense"]
            },
            /** グループユーザーの圃場管理を参照中は True */
            isShareMode: function () {
                if (this.$store.getters["shareMode"] == this.$store.getters["shareModeTypes"].groupUserWork) {
                    return true
                }
                return false
            },
            buttonGroupWidth: function () {
                return this.buttonGroupColumnNum * 120
            },
            buttonGroupHeight: function () {
                return this.buttonGroupRowNum * 120
            },
            /** ボタングループの列数 */
            buttonGroupColumnNum: function () {
                return 3 // this.$vuetify.breakpoint.xs ? 3 : 5
            },
            /** ボタングループの行数 */
            buttonGroupRowNum: function () {
                return 5 // this.$vuetify.breakpoint.xs ? 5 : 3
            },
            /** 指定された位置のボタン */
            button: function () {
                return function (x, y) {
                    const buttonNo = (y - 1) * this.buttonGroupColumnNum + x
                    return this.buttons.find((v)=>v.position == buttonNo && (this.isShareMode ? v.share : v.nonShare))
                }
            },
            /** 指定された位置のボタンに表示する画像のパス */
            buttonIconPath: function () {
                return function(x, y) {
                    const button = this.button(x, y)
                    if (button.icon == "") return ""
                    return require("@/assets/icons/"+(button.icon)+".png")
                }
            },
        },
        methods: {
            /**
             * メニューボタン押下時
             */
            onClick: function (button) {
                this.$emit("onClick", button)
            },
            onClickUserLicense: function () {
                this.$emit("onClickUserLicense")
            },
            onClickSetLicense: function () {
                this.$emit("onClickSetLicense")
            },
            onClickCustomize: function () {
                this.$emit("onClickCustomize")
            }
        }
    }
</script>